import { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./style.scoped.css";
import { OTP_LENGTH } from "src/constants";
import Button from "src/components/Button";

export interface OtpProps {
  onOk?: (otp: string) => void;
  onResend?: () => any;
  phone?: string;
  errOtp?: string;
  remainTime?: number;
  inputOtpHint?: string;
}

const Otp = ({
  onOk,
  onResend,
  phone,
  errOtp,
  remainTime,
  inputOtpHint
}: OtpProps) => {
  const inputRef = useRef<any[]>([]);
  const { t } = useTranslation();

  const _handleFocus = (e, i: number) => {
    let currentValue = _getCurrentValue();
    if (i > currentValue.length) {
      inputRef.current[currentValue.length]?.focus();
    }
  };

  const _getCurrentValue = () => {
    return inputRef.current
      .map((item) => item.value)
      .filter((item) => !!item)
      .join("")
      .replace(/\D/g, "");
  };

  const _handleChangeOtpItem = (e, i: number) => {
    if (e.target.value.length >= 1 && i < OTP_LENGTH - 1) {
      inputRef.current[i + 1]?.focus();
    }
  };

  const _handleKeyUp = (e, i: number) => {
    if (i > 0 && e.keyCode === 8) {
      inputRef.current[i - 1]?.focus();
    }
  };

  const _handleKeyDown = (e) => {
    let key = e.keyCode || Number(e.key);
    if (!((key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key === 8)) {
      e.preventDefault();
    }
  };

  const _renderOtpInput = () => {
    const listItem: any[] = [];
    for (let i = 0; i < OTP_LENGTH; i++) {
      listItem.push(
        <div
          key={i}
          className={
            (i < OTP_LENGTH - 1
              ? "otp-input-container"
              : "otp-input-container-last") +
            (errOtp ? " " + "otp-input-container-err" : "")
          }
        >
          <div>
          <input
            autoFocus={i === 0}
            className={errOtp ? "otp-input-item-err" : "otp-input-item"}
            maxLength={1}
            placeholder={"-"}
            type={"text"}
            inputMode={"numeric"}
            ref={(el) => (inputRef.current[i] = el)}
            onChange={(e) => _handleChangeOtpItem(e, i)}
            onKeyUp={(e) => _handleKeyUp(e, i)}
            onFocus={(e) => _handleFocus(e, i)}
            onKeyDown={_handleKeyDown}
          />
          </div>
        </div>
      );
    }
    return <>{listItem}</>;
  };

  const _handleResend = () => {
    if (onResend && remainTime <= 0) {
      onResend();
    }
  };

  const _handleConfirmOtp = () => {
    const otp = _getCurrentValue();
    onOk(otp);
  };

  return (
    <div className="otp-container">
      <div className="input-otp-hint text-center text-white">
        {inputOtpHint}
      </div>
      <div className="row-otp-items">{_renderOtpInput()}</div>
      {!!errOtp && <div className="invalid-text text-center">{errOtp}</div>}
      <div className="text-center text-white resend-container">
        {remainTime > 0 ? (<>
          {t("resend_otp")}{" "}
          <span>
            (<span className={"remain-time"}>{remainTime}</span>{" "}
            {t("second")})
          </span>
          </>
        ) : (
          ""
        )}
        <div 
          className="text-center text-white" 
          onClick={_handleResend}
          style={{
            opacity: remainTime <= 0 ? 1 : 0.5,
            cursor: remainTime <= 0 ? "pointer" : "auto",
          }}
        >{t('resend_otp_1')}</div>
      </div>
      <div className="bottomButtonBlock">
        <Button
          text={t('completed')}
          onClick={_handleConfirmOtp}
          extraClassName={'w-full'}
        />
      </div>
    </div>
  );
};

export default Otp;
